import { CommonModule, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { Router, NavigationEnd, ActivatedRoute, Data } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { TablerIconsModule } from 'angular-tabler-icons';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [RouterModule, CommonModule, TablerIconsModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: [],
})
export class AppBreadcrumbComponent implements OnInit {

  pageInfo: Data | any = {};
  myurl: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title
  ) {
    this.myurl = this.router.url.slice(1).split('/');
  }

  ngOnInit(): void {
    // Handle initial load (refresh)
    this.updateFromRoute(this.activatedRoute);

    // Handle all future navigations
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateFromRoute(this.activatedRoute);
      });
  }

  private updateFromRoute(route: ActivatedRoute) {
    while (route.firstChild) {
      route = route.firstChild;
    }

    route.data.subscribe(data => {
      this.pageInfo = { ...data };

      if (this.pageInfo?.urls) {
        const categoryId = this.activatedRoute.snapshot.paramMap.get('categoryid') || '';
        const itemId = this.activatedRoute.snapshot.paramMap.get('id') || '';

        this.pageInfo.urls = this.pageInfo.urls.map((url: { url: string; title: string }) => ({
          ...url,
          url: url.url
            ?.replace(':categoryid', categoryId)
            ?.replace(':id', itemId)
        }));
      }

    });
  }
}
